import { httpReservation } from 'shared/services/http/httpClient';
import { appUserModel } from '../models/appUsersModels';
import {
  appUserById,
  PayLoadAddCorporateUser,
  PayLoadAddParticularUser,
  PayLoadEditParticularUser,
  PayLoadEditUser,
  userAppBuilder
} from '../models/appUserModel';
import jwtDecode from 'jwt-decode';
import { UserRole } from 'app/user/models/User';
import environment from 'environment/environment';

export const appUsersService = () => {
  const getAppUsers = async (
    page: number = 1,
    page_size: number = 10,
    search: string | null = null,
    sort: string = 'created_at',
    sort_dir: string = 'ASC',
    user_type: string | null = null
  ): Promise<appUserModel> => {
    const res = await httpReservation.get('users', {
      params: {
        page,
        page_size,
        search,
        sort,
        sort_dir,
        ...(user_type ? { user_type } : {}),
      }
    });
    return res;
  };

  const changeActiveStatus = async (
    idUserApp: string,
    isActive: boolean,
    authorizedId: string | null
  ) => {
    return httpReservation.put(`users/${idUserApp}/change-status`, {
      state: isActive,
      authorized_id: authorizedId
    });
  };

  const addCorporateAppUser = async (values: PayLoadAddCorporateUser) => {
    const res = await httpReservation.post('users/register', values);
    return res;
  };

  const addParticularAppUser = async (values: PayLoadAddParticularUser) => {
    const res = await httpReservation.post('users/particular-register', values);
    return res;
  };

  const getAppUserById = async (id: string): Promise<appUserById> => {
    const res = await httpReservation.get(`users/${id}`);
    return userAppBuilder.fromBackEnd(res);
  };

  const editCorporateAppUser = async (values: PayLoadEditUser) => {
    const { id, ...rest } = values;
    const res = await httpReservation.put(`users/corporate/${id}`, rest);
    return res;
  };

  const editParticularAppUser = async (values: PayLoadEditParticularUser) => {
    const { id, ...rest } = values;
    const res = await httpReservation.put(`users/particular/${id}`, rest);
    return res;
  };

  const getRoles = () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode<{ roles: UserRole[] }>(token);
        return JSON.stringify(decoded.roles || []);
      } catch (error) {
        console.error('Error al decodificar el token para obtener los roles:', error);
        return '[]';
      }
    }
    return '[]';
  };

  const getUserId = () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode<{ user_id: number }>(token);
        return decoded.user_id?.toString() || '';
      } catch (error) {
        console.error('Error al decodificar el token para obtener el user_id:', error);
        return '';
      }
    }
    return '';
  };

  const deleteAppUser = async (id: string) => {
    const roles = getRoles();
    const user_id = getUserId();
    const res = await httpReservation.delete(`users-dt/${id}`, {
      headers: {
        roles,
        user_id
      }
    });
    return res;
  };

  const downloadExcel = async (values: any) => {
    const params = new URLSearchParams();

    if (values.dateFrom) {
      const fromDateISO = new Date(values.dateFrom).toISOString();
      params.append('from_date', fromDateISO);
    }

    if (values.dateTo) {
      const toDateISO = new Date(values.dateTo).toISOString();
      params.append('to_date', toDateISO);
    }

    const response = await fetch(
      `${environment.export}/users/export?${params.toString()}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        body: JSON.stringify({})
      }
    );

    if (!response.ok) {
      throw new Error('Error al descargar el informe de Excel');
    }

    return await response.json();
  };

  return {
    getAppUsers,
    changeActiveStatus,
    addCorporateAppUser,
    addParticularAppUser,
    getAppUserById,
    editCorporateAppUser,
    editParticularAppUser,
    deleteAppUser,
    downloadExcel
  };
};
